import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { IUserReducerProps } from '@common/interface';
import { logout } from './GeneralReducer';

export const initialState: IUserReducerProps = {
	memberId: null,
	dataId: null,
	isResetPassword: false,
	nric: '',
	passport: '',
	name: '',
	dateOfBirth: '',
	gender: '',
	nationality: '',
	residenceAddress1: '',
	residenceAddress2: '',
	residenceAddress3: '',
	residenceCity: '',
	residencePostcode: '',
	residenceState: '',
	residenceCountry: '',
	region: '',
	graduatedYear: '',
	mobileNo: '',
	mobileNoOther: '',
	email: '',
	schoolFaculty: '',
	highestProgramGraduated: '',
	campus: '',
	employmentType: '',
	employmentIndustrySector: '',
	employmentFunction: '',
	category: '',
	memberNo: '',
	status: '',
	admittedDate: '',
	hasExpiryDate: false,
	expiryDate: '',
};

export const userSlice = createSlice({
	name: 'User',
	initialState,
	reducers: {
		updateProfile: (state, action) => {
			return { ...state, ...action.payload };
		},
		resetProfile: () => initialState,
	},
	extraReducers: builder => {
		builder.addCase(logout, () => initialState);
	},
});

export const { updateProfile, resetProfile } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
